import type { CanManageDevelopmentUser } from '@/presentation/pages/developments/utils/resolve-can-manage-development.js';
import { resolveCanManageDevelopment } from '@/presentation/pages/developments/utils/resolve-can-manage-development.js';

export type CanImportDevelopmentUser = CanManageDevelopmentUser;

export function resolveCanImportDevelopment(user: CanImportDevelopmentUser): boolean {
    return resolveCanManageDevelopment(user);
}
